export type Condition<C> = boolean | ((ctx: C) => boolean);

/**
 *
 * @param condition
 * @param ctx
 * @returns
 */
export function evaluateCondition<C>(condition: Condition<C> | undefined, ctx: C): boolean {
    return typeof condition === 'function' ? condition(ctx) : !!condition;
}
